import React from 'react';

import { ExportStatistiquesViolationsDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import BaseDatePicker from 'components/BaseForm/BaseDatePicker';
import BaseForm from 'components/BaseForm/BaseForm';
import { FormInputProps } from 'components/BaseForm/types';
import { ExportStatistiquesFormValues } from 'pages/admin-fonctionnel/AdministrationAvancee/ExportStatistiques/types';
import { CSSUtils } from 'utils/CSSUtils';

import './ExportStatistiquesForm.less';

interface ExportStatistiquesFormProps {
  onSubmit: (values: ExportStatistiquesFormValues) => void;
  onCancel: () => void;
  inProgress: boolean;
  validate: (
    field: ExportStatistiquesViolationsDtoFormFieldEnum,
    changedValues: ExportStatistiquesFormValues,
  ) => Promise<void>;
  values: ExportStatistiquesFormValues;
  onChange?: (
    changedValues: Partial<ExportStatistiquesFormValues>,
    allValues: ExportStatistiquesFormValues,
  ) => ExportStatistiquesFormValues;
}

export function ExportStatistiquesForm({
  onSubmit,
  onCancel,
  inProgress,
  validate,
  values,
  onChange,
}: ExportStatistiquesFormProps) {
  const inputs: FormInputProps<
    ExportStatistiquesFormValues,
    ExportStatistiquesViolationsDtoFormFieldEnum
  >[] = [
    {
      field: ExportStatistiquesViolationsDtoFormFieldEnum.DATE_DEBUT,
      label: 'Date de début',
      name: 'dateDebut',
      dependencies: ['dateFin'],
      render: () => {
        return <BaseDatePicker />;
      },
    },
    {
      field: ExportStatistiquesViolationsDtoFormFieldEnum.DATE_FIN,
      label: 'Date de fin',
      name: 'dateFin',
      dependencies: ['dateDebut'],
      render: () => {
        return <BaseDatePicker />;
      },
    },
  ];

  return (
    <BaseForm
      initialValues={values}
      validateField={validate}
      onSubmit={onSubmit}
      onChange={onChange}
      inputs={inputs}
      renderButtonAction={(Submit, Cancel) => {
        return (
          <div className="RenderButtonActionContainer">
            <div className="RenderButtonAction">{Cancel}</div>
            <div className="RenderButtonAction">{Submit}</div>
          </div>
        );
      }}
      submitText={'Télécharger les statistiques'}
      isSubmitting={inProgress}
      cancelButtonLabel={'Réinitialiser'}
      onCancel={onCancel}
      wrapperCol={{ span: CSSUtils.LlargeWrapperCol }}
    />
  );
}
